module.exports = __webpack_public_path__ + "static/media/Jugalbandi.8fdf809b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Jugalbandi.gif
// module id = 318
// module chunks = 0